import {useState} from "react";
import {PAGE_LENGTH} from '@/utils/constants/constants';

export const useDataQueries = () => {
    const [pageNo, setPageNo] = useState<any>(1);
    const [dataLength, setDataLength] = useState<any>(PAGE_LENGTH);
    const [sorting, setSorting] = useState<any>({created_at: -1})
    const [filter, setFilter] = useState<any>({});
    const [searchItem, setSearchItem] = useState<any>(null)

    const resetDataQueries = () => {
        setPageNo(1)
        setDataLength(PAGE_LENGTH)
        setSorting({created_at: -1})
        setSearchItem(null)
        setFilter({})
    }

    return [ pageNo, setPageNo, dataLength, setDataLength, sorting, setSorting, filter, setFilter, searchItem, setSearchItem,resetDataQueries ]
}